import React, {useState} from 'react';
import Activities from "../Activities/Activities";
import Info from "../Info/Info";


const MainSection = () => {
    const [exerciseTime, setExcerciseTime] = useState(0);

    const timeHandler = (newTime) => {
        setExcerciseTime(exerciseTime + newTime);
    };

    return (
        <div className="container mx-auto p-5 grid grid-cols-1 md:grid-cols-4 md:gap-7">
            <Activities timeHandler={timeHandler}></Activities>
            <Info exerciseTime={exerciseTime}></Info>
        </div>
    );
};

export default MainSection;